
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { GeoFenceRemoveRequest } from '../entities/geofenceConfigurations-v1/geoFence-delete-request';
import { GeoFenceRemoveResponsePayload } from '../entities/geofenceConfigurations-v1/geoFenceRemoveResponsePayload';
import { axiosInstance } from "../axios-instance";

class GeoFenceConfiguration {

  private client: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.client = authClient;
    this.baseUrl = baseUrl;
  }

  removeConfigs(
    body: GeoFenceRemoveRequest,
  ): Promise<AxiosResponse<GeoFenceRemoveResponsePayload>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<GeoFenceRemoveResponsePayload>(`${this.baseUrl}/removeConfigs`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default GeoFenceConfiguration;
